/** Attribution stays in memory for this tab. No cookie, storage, device id or tracking pixel. */
export type SocialAcquisition = { postId: string; source: string };
let first: SocialAcquisition | null = null;
export function readSocialAcquisition(params: URLSearchParams): SocialAcquisition | null {
  const postId = /^social-(c[a-z0-9]{20,30})$/.exec(params.get("utm_campaign") ?? "")?.[1];
  const source = params.get("utm_source") ?? "";
  return postId && ["instagram", "facebook", "linkedin"].includes(source) ? { postId, source } : null;
}
export function captureSocialAcquisition(): SocialAcquisition | null {
  if (typeof window !== "undefined") first ??= readSocialAcquisition(new URLSearchParams(window.location.search));
  return first;
}
